import Vue from "vue";
import Vuex from "vuex";
import pageOptions from "./modules/pageOptions";
import personOptions from "./modules/personOptions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    pageOptions,
    personOptions
  }
});
